/**
 * Линейная шкала: значение из домена → пиксель.
 * Время на оси X передаётся миллисекундами (getTime).
 */
class ChartScale {
  readonly domainStart: number;

  readonly domainEnd: number;

  readonly rangeStart: number;

  readonly rangeEnd: number;

  constructor(domainStart: number, domainEnd: number, rangeStart: number, rangeEnd: number) {
    this.domainStart = domainStart;
    this.domainEnd = domainEnd;
    this.rangeStart = rangeStart;
    this.rangeEnd = rangeEnd;
  }

  /** Пиксель для значения. Домен нулевой ширины — середина диапазона */
  toPixel(value: number): number {
    if (this.domainEnd === this.domainStart) {
      return (this.rangeStart + this.rangeEnd) / 2;
    } else {
      return this.rangeStart + (value - this.domainStart) / (this.domainEnd - this.domainStart) * (this.rangeEnd - this.rangeStart);
    }
  }

  /**
   * «Круглый» шаг делений: 1, 2 или 5, умноженные на степень десяти.
   *
   * @example
   * ChartScale.niceStep(1000, 5) // 200
   * ChartScale.niceStep(37, 4)   // 10
   */
  static niceStep(range: number, count: number): number {
    const raw = range / count;
    const magnitude = Math.pow(10, Math.floor(Math.log10(raw)));
    const normalized = raw / magnitude;

    let nice: number;

    if (normalized <= 1) {
      nice = 1;
    } else if (normalized <= 2) {
      nice = 2;
    } else if (normalized <= 5) {
      nice = 5;
    } else {
      nice = 10;
    }

    return nice * magnitude;
  }

  /**
   * Деления с круглым шагом внутри [min, max].
   *
   * @example
   * ChartScale.ticks(13, 97, 4) // [20, 40, 60, 80]
   */
  static ticks(min: number, max: number, count: number): number[] {
    const step = this.niceStep(max - min, count);
    const result: number[] = [];

    for (let value = Math.ceil(min / step) * step; value <= max; value += step) {
      // Убираем хвосты плавающей точки: 0.30000000000000004 → 0.3
      result.push(Number(value.toPrecision(12)));
    }

    return result;
  }
}

export default ChartScale;
